<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

    <ng-container *ngIf="consulta">

        <ul class="card-list-striped">
            <li>
                <span class="text-secondary">Placa</span>
                <span>{{consulta?.placa || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Chassi</span>
                <span>{{consulta?.chassi || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Renavam</span>
                <span>{{consulta?.renavam || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Ano Fabricação</span>
                <span>{{consulta?.anoFabricacao || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Modelo</span>
                <span>{{consulta?.modelo || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Marca</span>
                <span>{{consulta?.marca || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Autuações</span>
                <span>{{consulta?.autuacoes || "NÃO INFORMADO"}}</span>
            </li>
            <li>
                <span class="text-secondary">Valor Multas</span>
                <span>{{consulta?.valorDebitoMulta || "NÃO INFORMADO"}}</span>
            </li>
        </ul>

        <div class="card-msg d-flex flex-column bg-white text-dark text-center" *ngIf="texto!=null">
            {{texto}}
        </div>

        <ng-container *ngIf="texto==null">
            <div  *ngFor="let m of consulta.listaDadosCertificadoSeguranca; let i = index" >
                <h2 class="subtitle subtitle">Certificados de segurança {{m?.ano || "NÃO INFORMADO"}}</h2>
                <ul class="card-list-striped">
                    <li>
                        <span class="text-secondary">Ano</span>
                        <span>{{m?.ano || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CSV </span>
                        <span>{{m?.csv || "NÃO INFORMADO"}}</span>
                    </li>
                    <li>
                        <span class="text-secondary">Discriminacao</span>
                        <span>{{m?.discriminacao || "NÃO INFORMADO"}}</span>
                    </li>
                </ul>
            </div>
        </ng-container>



    </ng-container>

</app-card-consulta>
